import '../styles/index.scss';

import 'intersection-observer';

import * as navigation from './components/navigation';
import * as analytics from './components/analytics/analytics';

import * as ballPitChart from './custom/ball-pit-chart';
import * as reproductionChart from './custom/reproduction-chart';

window.addEventListener('load', init);

function init() {
  navigation.init();

  analytics.init({
    serviceUrl: 'https://ddj.br.de/analytics/track',
    projectId: 'corona-simulation',
    tracker: {
      client: true,
      click: true,
      observer: true,
      timer: true,
      custom: true
    },
    respectDoNotTrack: false,
    debug: false
  });

  const ballPit1 = ballPitChart.init({
    id:'ball_pit_1',
    movingRatio:1
  });

  const ballPit2 = ballPitChart.init({
    id:'ball_pit_2',
    movingRatio:0.2,
    maxSteps:2000
  });

  const reproduction = reproductionChart.init({
    id:'reproduction_chart_1'
  });

  resizeHandler(ballPit1, ballPit2, reproduction);
}

function resizeHandler(...charts) {
  let timeout;

  window.onresize = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      charts.forEach(chart => {
        chart.resize();
      });
    }, 200);
  };
}
